import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, EMPTY, tap } from 'rxjs';
import { Router } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private router: Router, private snackbarService: SnackbarService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = sessionStorage.getItem('token') || localStorage.getItem('hrms_token');

    const url = request.url;
    const isPublic =
      url.includes('/auth/') ||
      url.endsWith('/login') ||
      url.includes('/candidates/by-token/') ||
      /\/candidates\/[^/]+\/submit$/.test(url) ||
      (request.method === 'PATCH' && /\/candidates\/[^/]+$/.test(url));

    if (!token && !isPublic) {
      return EMPTY;
    }

    if (token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }

    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (!(err instanceof HttpErrorResponse)) return;

          if (err.status === 401) {
            sessionStorage.removeItem('token');
            localStorage.removeItem('hrms_token');
            if (!isPublic) {
              this.snackbarService.showFailure('Session expired. Please log in again.');
              sessionStorage.setItem('redirect_url', this.router.url);
              this.router.navigate(['login']);
            } else {
              this.snackbarService.showFailure('Invalid credentials');
            }
            return;
          }

          if (request.method === 'GET') {
            return;
          }

          if (err.status === 400) {
            this.snackbarService.showFailure(err.error?.message || 'Bad request');
            return;
          }

          if (err.status === 403) {
            return;
          }
        }
      })
    );
  }
}
